/**
 * Home page - displays list of quizzes
 */

import React from 'react';
import QuizList from '../components/QuizList';

export default function Home() {
    return (
        <div style={{ padding: '2rem' }}>
            <QuizList />
        </div>
    );
}
